// The site a visitor wanted to monitor from a free tool (website checker),
// kept across signup and checkout so the new-monitor form can start with it.
const KEY = 'uptrack_pending_monitor_url'
const MAX = 500

/** Only http(s) URLs, trimmed and capped. Pure. */
export function cleanMonitorUrl(raw: unknown): string | undefined {
  if (typeof raw !== 'string') return undefined
  const v = raw.trim()
  // Too long is refused, not cut: a cut URL would be a different page.
  if (v.length > MAX) return undefined
  return /^https?:\/\/[^\s]+$/i.test(v) ? v : undefined
}

export function rememberMonitorUrl(url: string) {
  const v = cleanMonitorUrl(url)
  if (!v) return
  try {
    localStorage.setItem(KEY, v)
  } catch {
    // Storage unavailable: the form simply starts empty.
  }
}

/** The remembered URL, removed as it is read (used once). */
export function takePendingMonitorUrl(): string | undefined {
  try {
    const v = cleanMonitorUrl(localStorage.getItem(KEY))
    localStorage.removeItem(KEY)
    return v
  } catch {
    return undefined
  }
}
